module.exports = __webpack_public_path__ + "static/media/mc_pulse_invalid.e4d3ab29.svg";